import React from 'react';

import type {Ability} from '../../../../../generated/types';
import {useCharacter} from '../../character-context';

import css from '../master.module.css';

type Props = {
	ability: Ability;
	/** базовое значение ещё не выбрано: итог не показывается */
	isEmpty?: boolean;
	children: React.ReactNode;
};

/** поле базового значения и итог с повышениями от происхождения, черт и особенностей */
export const AbilityRow: React.FC<Props> = ({ability, isEmpty, children}) => {
	const {character} = useCharacter();
	return (
		<div className={css.abilityInput}>
			{children}
			<span className={css.abilityTotal}>= {isEmpty ? '—' : character.abilityScore(ability)}</span>
		</div>
	);
};
